import { Button, Tooltip } from 'antd'
import React from 'react'

const ButtonD = ({
  tooltip,
  shape,
  icon,
  type,
  text,
  redirect,
}) => (
  <Tooltip title={tooltip}>
    <Button
      onClick={() => redirect(tooltip)}
      type={type}
      shape={shape}
      icon={icon}
      size="large"
    >
      {text}
    </Button>
  </Tooltip>
)

export default ButtonD
